import * as React from 'react';
import { cn } from '../../lib/cn';

export const AppHeader = React.forwardRef<HTMLElement, React.HTMLAttributes<HTMLElement>>(
  ({ className, ...props }, ref) => (
    <header
      ref={ref}
      className={cn(
        // MP89 — sticky top-0 + z-20 so the header stays pinned
        // when the page scrolls. Belt-and-suspenders: AppContent
        // already owns overflow-auto so the header normally
        // doesn't move, but `sticky` keeps it in place even on
        // layouts where the outer scroll container is the body
        // (e.g. very tall sidebars on narrow viewports).
        'sticky top-0 z-20 flex h-14 shrink-0 items-center gap-4 border-b bg-background/95 px-4 backdrop-blur',
        'supports-[backdrop-filter]:bg-background/60',
        className,
      )}
      {...props}
    />
  ),
);
AppHeader.displayName = 'AppHeader';

export const AppHeaderLeft = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('flex flex-1 items-center gap-4', className)} {...props} />
  ),
);
AppHeaderLeft.displayName = 'AppHeaderLeft';

export const AppHeaderRight = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('flex items-center gap-2', className)} {...props} />
  ),
);
AppHeaderRight.displayName = 'AppHeaderRight';
